<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn
        class="cvc-button float-right"
        style="width: 270px"
        depressed
        :disabled="disabled"
        v-on="on"
      >
        Submit
      </v-btn>
    </template>

    <v-card color="colorf">
      <v-card-title>
        <span class="pl-2 pt-2 font-size-medium-large font-weight-medium">
          Are you sure?
        </span>
      </v-card-title>
      <v-card-text class="mt-3">
        <span>
          Are you sure you wish to send this notification to '{{ brandName }}'?
        </span>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="sendingMessage"
          class="cvc-button"
          depressed
          width="100px"
          @click="hideDialogForAction"
        >
          No
        </v-btn>
        <v-btn
          :disabled="sendingMessage"
          class="cvc-button"
          depressed
          width="100px"
          @click="postProfileAction"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  // import { parseISO, format, addSeconds } from 'date-fns';
  export default {
    name: 'SendNotificationModal',
    props: {
      disabled: {
        type: Boolean,
        required: true,
      },
      formData: {
        type: Object,
        required: true,
      },
      brand: {
        type: Object,
        required: true,
      },
      resetFormData: {
        type: Function,
        required: true,
      },
    },
    data() {
      return {
        dialog: null,
        sendingMessage: false,
      };
    },
    computed: {
      brandName() {
        return this.$store.state.dailyCounts.brand.name;
      },
    },
    methods: {
      postProfileAction() {
        this.sendingMessage = true;
        return this.$store
          .dispatch('postProfileActionData', {
            action: this.formData,
            brand: this.brand,
          })
          .then(() => {
            this.resetFormData();
            this.hideDialogForAction();
          })
          .finally(() => {
            this.sendingMessage = false;
          });
      },
      hideDialogForAction() {
        this.dialog = false;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
